import moment from 'moment';

import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';

function DateItem({ date, handleClickDate }) {
  return (
    <div
      className="flex flex-row items-center py-3 px-3 shadow-sm gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-fit mb-2"
      onClick={handleClickDate}>
      {/* <img
          className="h-32 w-32 object-cover shadow-md block rounded-md"
          src={date.image ? date.image.file : getImage('img-ph.png')}
          alt={date.image ? date.image.label : 'Non renseignée'}
        /> */}
      <div className="flex flex-col gap-y-1 h-full w-full">
        <div className="flex flex-col gap-y-1">
          <div className="text-xl font-bold text-slate-700 ">
            {moment(date.date).format('LL')}
          </div>
          <div className="flex flex-col gap-1">
            <span className="font-medium text-slate-700">{date.schedule}</span>
            <span className="font-medium text-slate-700">{date.details}</span>
          </div>
        </div>
        <div className="flex flex-row gap-x-3">
          <Tag
            tag={{
              label: getConstant('quatrebis.dateType', date.type).label,
              icon: 'star',
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DateItem;
